import { Create, SimpleForm } from "react-admin";
import { OrganEventForm } from "./OrganEventForm";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { useCreateSubmit } from "../../forms";

const OrganEventCreateForm = () => {
	const submit = useCreateSubmit("organ-events", "Event created", {
		resource: "organs",
		idColumn: "organ_id",
		view: "show",
		subPath: "events",
	});

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<OrganEventForm />
		</SimpleForm>
	);
};

export const OrganEventCreate = () => {
	return (
		<Create title="Create event">
			<OrganEventCreateForm />
		</Create>
	);
};
